<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{ "bikeshop.account.card_details" | translate }}
    </h4>
    <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="close()"
    >
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">
    <div style="display: flex; justify-content: center;">
        <img
                style="width: 500px;"
                src="../../../../assets/secure-stripe-payment-logo.png"
                alt=""
        />
    </div>
    <div class="loading" *ngIf="loading">
        <div class="loader"></div>
    </div>
    <h6>{{ "bikeshop.account.credit_or_debit_card" | translate }}</h6>
    <div class="flex_row">
        <div class="cell card-container card1" id="card-1">
            <form id="payment-form">
                <fieldset>
                    <div class="row">
                        <div id="card-input"></div>
                    </div>
                </fieldset>
            </form>
        </div>
        <button [disabled]="loading" id="submit_button" (click)="submitPayment()">
            <div *ngIf="loading">
                Processing...
            </div>
            <div *ngIf="!loading">
                {{ "bikeshop.account.submit_payment" | translate }}
            </div>
        </button>
    </div>
    <div class="coupon-code">
        <input type="text" pInputText [(ngModel)]="coupon" placeholder="{{ 'bikeshop.account.coupon' | translate }}"/>
    </div>
    <div id="card-errors" role="alert"></div>
    <hr/>
    <div class="purchase-summary">
        {{ "bikeshop.account.this_is_a_recurring_payment_for" | translate }}
        <span style="font-weight: 700;">{{
            chosenPackage.pricing.amount / 100
                | currency: chosenPackage.pricing.currency.toUpperCase()
            }}</span>
        {{ "bikeshop.account.that_will_be_processed_monthly_on_every" | translate }}
        <span style="font-weight: 700;">{{ firstPayDay.format("Do") }}
    </span>
        {{"bikeshop.account.starting" | translate }}
    </div>
    <hr/>
    <div class="cost-summary">
        <div class="line-item">
            <div>{{ "bikeshop.account.merchant" | translate }}</div>
            <div class="line-item">
                {{ "bikeshop.account.hubtiger" | translate }}
            </div>
        </div>
        <div class="line-item">
            <div>{{ "bikeshop.account.transaction_date" | translate }}</div>
            <div>
                <!--        {{ processedDate | date: "dd MMM yyyy" }}-->
            </div>
        </div>
        <div class="line-item">
            <div>{{ chosenPackage.name }}</div>
            <div class="total">
                {{
                chosenPackage.pricing.amount / 100
                    | currency: chosenPackage.pricing.currency.toUpperCase()
                }}
            </div>
        </div>
    </div>
</div>

<!-- [disabled]="buttonDisabled" -->
